import script from "./ModalIos.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalIos.vue?vue&type=script&setup=true&lang=js"

import "./ModalIos.vue?vue&type=style&index=0&id=4a0aecc2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a0aecc2"]])

export default __exports__